import React, { useState } from 'react'
import SubHeader from '../general/SubHeader'
import { useNavigate } from 'react-router-dom';

const Login = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (username === 'omanshiadmin' && password === 'admin8858@travels') {
      // If they match, navigate to the dashboard
      localStorage.setItem('username', username);
      localStorage.setItem('isLoggedIn', 'true');
      navigate('/admin/dashboard');
      window.location.reload();
    } else {
      // Optionally handle invalid login
      alert('Invalid username or password');
    }
  }

  return (
    <>
      <SubHeader message="Login" />

      <section className='py-5 bg-light px-lg-5 px-4'>
        <div className='login-form-area'>
          <i class="fa-solid fa-user-tie login-icon"></i>
          <p className='sec-subheading'>Admin Login</p>

          <form class="row g-3 my-4" onSubmit={handleLogin}>
            <div class="col-12">
              <input type="text" class="form-input" id="inputText4" value={username} onChange={(e) => setUsername(e.target.value)} placeholder='Username' />
            </div>
            <div class="col-12">
              <input type="password" class="form-input" id="inputPassword4" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Password' />
            </div>
            <div class="col-12">
              <button type="submit" class="slider-btn w-100">Login</button>
            </div>
          </form>
        </div>
      </section>
      {/* login form ends */}

    </>
  )
}

export default Login
